import { useTranslation } from "react-i18next";
import { Heading, Text, YStack } from "tamagui";

import CustomCard from "../../components/CustomCard";

export const SensorManuals = () => {
  const { t } = useTranslation();

  return (
    <YStack gap="$4">
      <YStack gap="$2">
        <Text fontSize="$5.5">{t("sidebar.settings.settings")}</Text>
        <Heading fontSize="$8">{t("sidebar.settings.sensorManuals")}</Heading>
      </YStack>
      <YStack gap="$3.5">
        <CustomCard
          label={t("sensorManuals.baseStation")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.leakDetector")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.waterQualityMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.airQualityMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.powerMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.hvacAirhandlerMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.hvacCondenserMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
      </YStack>
    </YStack>
  );
};
export default SensorManuals;
